<template lang="pug">
.testmail-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="send")
    div(slot="modal-title")
      span 以下の内容でメッセージを送信します。よろしいですか？

    .testmail-modal-body
      .register-body
        FormLabel(key-name="宛先" :value="_target")
        FormLabel(key-name="タイトル" :value="_subject")
        FormLabel(key-name="本文" :value="_text")

    .testmail-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }")
      .buttons
        button.btn.modal-ok-btn(type="button" @click="ok()") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import FormLabel from "@/pc/components/forms/FormLabel.vue";

/**
 * メッセージ送信確認モーダル
 */
@Component({
  components: {
    FormLabel
  }
})
export default class TestMailConfirmModal extends Vue {
  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  @Prop({
    default: () => {
      return "";
    }
  })
  target!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  subject!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  text!: string;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _target(): string {
    return this.target;
  }

  get _subject(): string {
    return this.subject;
  }

  get _text(): string {
    return this.text;
  }

  /**
   * ### 送信ボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public send(modalEvent: any): void {
    modalEvent.preventDefault();
    this.$emit("sendMail");

    return;
  }
}
</script>
